module.exports = __webpack_public_path__ + "static/anne_fuhrmann-4a7c84ac85efe470d03aac608827721c.jpg";